package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.*

@Composable
fun HorizontalSpacer(width: CSSLengthOrPercentageNumericValue = 1.cssRem) {
    Box(modifier = Modifier.width(width))
}
